module.exports = __webpack_public_path__ + "static/media/tickIcon.fcad0262.svg";